import React, { ReactNode, ReactElement, forwardRef, memo } from 'react';
// import Link from '@mui/material/Link';
import styled from '@emotion/styled';
import NextLink from 'next/link';
import { addCampaignCode, CampaignCode } from 'presentations/routes/helper';

type ColorType = 'primary' | 'secondary' | 'textPrimary';

interface Props {
  children?: ReactNode;
  href?: string;
  onClick?: any;
  color?: ColorType;
  target?: string;
  rel?: string;
  className?: string;
  dataProps?: any;
  campaign?: CampaignCode;
  withoutNextLink?: boolean;
  locale?: string;
}

const Component = memo((props: Props) => {
  const dataProps = props.dataProps || {};
  let href = props.href;
  if (props.href) {
    if (props.campaign) {
      href = addCampaignCode(props.href, props.campaign);
    }
  }

  const linkProps = {
    href: href || '#',
    target: props.target,
    rel: props.rel,
    className: props.className,
    color: props.color || 'primary',
    onClick: props.onClick,
    ...dataProps,
  };

  return typeof href === 'string' && !props.withoutNextLink ? (
    <NextLink {...linkProps}>{props.children}</NextLink>
  ) : (
    <Styled {...linkProps}>{props.children}</Styled>
  );
});

export const NativeLink = memo((props: Props) => {
  return <Component {...props} withoutNextLink />;
});

/* const Styled = styled(Link)` */
const Styled = styled.a`
  cursor: pointer;
  :hover {
    text-decoration: none;
  }
`;

export default Component;
